<template>
    <div class="bordas acoes-content">
        <button type="button" class="btn btn-secondary btn-sm btn-acoes" @click="desconhecidos()">
            Pacientes sem identificação: {{semCns}}
        </button>
    </div>
</template>

<script>
export default {
    computed: {
        listagemFiltradaStatus () {
            return this.$store.getters['leitos/getListagemFiltradaStatus']
        },
        listagemMapaLeitos () {
            return this.$store.getters['leitos/getListagemMapaLeitos']
        },
        semCns () {
            let total = this.listagemMapaLeitos.dados.filter(i => i.pacienteCns && i.pacienteCns.length < 15)
            return total.length
        },
    },
    methods: {
        desconhecidos () {
            this.$store.commit('transferir/setLeitoTransferencia', null)

            this.listagemFiltradaStatus == 22 ?
                this.$store.commit('leitos/setListagemFiltradaStatus', null) :
                this.$store.commit('leitos/setListagemFiltradaStatus', 22)
        },
    }
}
</script>

<style>
.covid-icone-botao {
    margin-right: 6px;
    display: inline-block;
    color: #fff;
    text-align: center;
    font-weight: 700;
    background-color: #451690;
    width: 14px;
    font-size: .8rem;
    border-radius: 8px;
}

.btn-outline-purple {
    color: #250d54;
    border-color: #250d54;
}

.btn-outline-purple:hover,
.btn-purple {
    color: #fff;
    background-color: #250d54;
    border-color: #250d54;
}
</style>

